/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* planbord.module.ts
* 19-11-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {NgModule} from '@angular/core';
import {Planblock, PlanblockDag, PlanblockRij, Planbordscherm} from './planbord';
import {SihwdatepickerModule} from 'sihw-ng/controls/sihwdatepicker/sihwdatepicker.module';
import {SihwsemaphoreModule} from 'sihw-ng/semaphore/sihwsemaphore.module';
import {Planitemedit} from './planitemedit';
import {PlanitemInvullingComponent} from './planitem-invulling.component';
import {PlanitemMultiInvulling} from './multi-invulling/planitem-multi-invulling';
import {SihwtijdveldModule} from 'sihw-ng/controls/sihwtijdveld/sihwtijdveld.module';
import {SihwDragToScrollModule} from 'sihw-ng/sihwdragtoscroll/dragtoscroll.module';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {PersoneelcommentEdit, ProjectcommentEdit} from './commentedit';
import {VerwijderdePlanitems} from './verwijderdeplanitems';
import {MdatepipeModule} from 'sihw-ng/pipes/mdate/mdatepipe.module';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {CommonModule} from '@angular/common';
import {TabsModule} from 'ngx-bootstrap/tabs';

@NgModule({
  declarations: [Planbordscherm, Planblock, PlanblockDag, PlanblockRij, Planitemedit, PersoneelcommentEdit, ProjectcommentEdit, VerwijderdePlanitems, PlanitemMultiInvulling],
  imports: [
    CommonModule,
    SihwdatepickerModule,
    SihwsemaphoreModule,
    SihwtijdveldModule,
    SihwDragToScrollModule,
    BsDatepickerModule,
    MdatepipeModule,
    FormsModule,
    NgSelectModule,
    TabsModule,
      PlanitemInvullingComponent
  ],
  exports: [Planbordscherm, PersoneelcommentEdit, ProjectcommentEdit, VerwijderdePlanitems, PlanitemMultiInvulling]
})
export class PlanbordModule {
}

//we registreren het planbord hier, want het werkt niet goed in de class-file zelf
Planbordscherm.register('Planbordscherm');
Planitemedit.register('Planitemedit');
PersoneelcommentEdit.register('PersoneelcommentEdit');
ProjectcommentEdit.register('ProjectcommentEdit');
VerwijderdePlanitems.register('VerwijderdePlanitems');
PlanitemMultiInvulling.register('PlanitemMultiInvulling');
